module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/win11-start-dark-bgimage.84d88afa.svg";